<template>
  <private-gym-page id="video-techniek-page" name="home" :has_fab="false">

    <f7-block-title>
      Eiland instructies
    </f7-block-title>

    <f7-list class="list-strong list-outline list-dividers">
      <video-link-item v-for="(video, index) in videos_sorted"
                       :video="video"
                       :query="query"
                       :show="videoSheetStates[index]"
                       @opened="updateVideoSheetsState(index, true)"
                       @closed="updateVideoSheetsState(index, false)"
      >
      </video-link-item>
    </f7-list>
  </private-gym-page>


</template>

<script>

import PrivateGymPage from "./../_layouts/PrivateGymPage.vue";
import {f7, f7ready, theme} from 'framework7-vue';
import VideoSheet from "../../components/videos/VideoSheet.vue";
import VideoLinkItem from "../../components/videos/VideoLinkItem.vue";
import utility from "../../js/utility";

export default {
  components: {
    VideoLinkItem,
    VideoSheet,
    PrivateGymPage,
  },

  props: {
    f7route: Object,
    f7router: Object,
    has_fab: {default: false}
  },

  setup(props) {
    const {f7route, f7router} = props;
  },

  mixins: [],

  data: function () {
    return {
      theme,
      query: '',
      videoSheetStates: [],
      videos: [
        {
          title: "Powerrack beugels (Monolifts)",
          src: "https://iframe.mediadelivery.net/embed/94838/f4114efd-2613-47ca-84d9-88a62509f896"
        },
        {
          title: "Leg Extension",
          src: "https://iframe.mediadelivery.net/embed/94838/04cc41d0-859c-4097-85cc-8fb7d9edb7d4"
        }
      ],
      myPhotoBrowserVideo: null,
    };
  },

  computed: {
    current_user() {
      return this.$store.state.current_user.data;
    },
    is_logged_in() {
      return this.$store.getters['current_user/token'].length > 0;
    },
    videos_sorted() {
      return utility.sortObjectByKey(this.videos, 'title');
    },
  },

  created() {
    //
  },

  mounted() {
    this.setVideoSheetsState();
  },

  methods: {
    openVideo() {
      this.myPhotoBrowserVideo.open();
    },
    setVideoSheetsState() {
      this.videos.forEach((video, index) => {
        this.videoSheetStates.push(false);
      })
    },
    updateVideoSheetsState(index, state) {
      this.videoSheetStates[index] = state;
    }
  },

  watch: {
    //
  }
};
</script>
<style>

</style>
